import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/**
 * 공통 WYSIWYG 에디터 (CKEditor 5 Classic Build 기준).
 * - value: HTML 문자열, onChange(html): 변경 시 콜백
 * - CKEditor 는 완전한 제어 컴포넌트가 아니라 최초 data 로만 초기화되므로,
 *   부모가 value 를 외부에서 갈아끼우는 경우(예: 다른 항목 편집으로 전환)에는
 *   컴포넌트를 새로 마운트해야 한다 (사용하는 쪽에서 key prop 으로 처리 권장).
 */
export default function RichTextEditor({ value, onChange, placeholder, disabled = false }) {
  return (
    <div className="rte">
      <CKEditor
        editor={ClassicEditor}
        data={value || ''}
        disabled={disabled}
        config={{
          placeholder,
          toolbar: [
            'heading', '|',
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
            'insertTable', 'undo', 'redo', '|',
            'removeFormat',
          ],
        }}
        onChange={(event, editor) => {
          onChange(editor.getData());
        }}
      />
    </div>
  );
}
